import React from 'react';
import Icon from '../AppIcon';

const AnalysisStatusIndicator = ({ 
  status = 'pending',
  progress = 0,
  message = '',
  estimatedTime = null,
  onRetry = null
}) => {
  const statusConfig = {
    pending: {
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      label: 'Analysis Pending'
    },
    processing: {
      icon: 'Loader2',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      label: 'Analyzing Property'
    },
    complete: {
      icon: 'CheckCircle2',
      color: 'text-success',
      bgColor: 'bg-success/10',
      label: 'Analysis Complete'
    },
    error: {
      icon: 'AlertCircle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      label: 'Analysis Failed'
    }
  };

  const config = statusConfig?.[status] || statusConfig?.pending;

  return (
    <div className="w-full bg-card rounded-lg border border-border p-6 shadow-elevation-sm">
      <div className="flex items-start gap-4">
        <div className={`${config?.bgColor} p-3 rounded-lg flex-shrink-0`}>
          <Icon 
            name={config?.icon} 
            size={24} 
            color={`var(--color-${status === 'processing' ? 'primary' : status === 'complete' ? 'success' : status === 'error' ? 'error' : 'warning'})`}
            className={status === 'processing' ? 'animate-spin' : ''}
          />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-2">
            <h3 className={`text-lg font-semibold ${config?.color} font-heading`}>
              {config?.label}
            </h3>
            {estimatedTime && status === 'processing' && (
              <span className="text-sm text-muted-foreground text-caption">
                ~{estimatedTime}
              </span>
            )}
          </div>

          {message && (
            <p className="text-sm text-foreground mb-4 font-body">
              {message}
            </p>
          )}

          {status === 'processing' && (
            <div className="space-y-2">
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground text-caption">Progress</span>
                <span className="font-medium text-data">{progress}%</span>
              </div>
              <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
                <div 
                  className="h-full bg-primary transition-all duration-500 ease-out rounded-full"
                  style={{ width: `${progress}%` }}
                />
              </div>
            </div>
          )}

          {status === 'error' && onRetry && (
            <button
              onClick={onRetry}
              className="mt-4 inline-flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-base text-sm font-medium"
            >
              <Icon name="RefreshCw" size={16} color="currentColor" />
              <span>Retry Analysis</span>
            </button>
          )}

          {status === 'complete' && (
            <div className="mt-4 flex items-center gap-2 text-sm text-success">
              <Icon name="CheckCircle2" size={16} color="currentColor" />
              <span className="font-medium">Ready to view results</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnalysisStatusIndicator;